import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import DashboardLayout from "src/layouts/dashboard";
import AccountPage from 'src/pages/dashboard/user/account';


const IndexPage = lazy(() => import('src/pages/dashboard/shop-admin-page'));
const ActiveBuildList = lazy(() => import('src/pages/main-dashboard/build-mode/build-list'));
const BuildDetailPage = lazy(() => import('src/pages/main-dashboard/build-mode/build-detail'));
const ShopAdminNotificaitonPage = lazy(() => import('src/pages/main-dashboard/build-mode/shop-admin-notification'));
const MessageBoard = lazy(() => import('src/pages/main-dashboard/build-mode/messge-board'));

export const ShopAdminDashboard = [
    {
        path: 'shop-admin',
        element: (
            <AuthGuard>
            <DashboardLayout>
                <Suspense fallback={<LoadingScreen />}>
                    <Outlet />
                </Suspense>
            </DashboardLayout>
             </AuthGuard>
        ),
        children: [
            { element: <IndexPage />, index: true },
            { path: 'build-list', element: <ActiveBuildList /> },
            { path: 'build-detail/:id', element: <BuildDetailPage /> },
            { path: 'notifications', element: <ShopAdminNotificaitonPage /> },
            { path: "message-board", element: <MessageBoard /> },
            { path: "account", element: <AccountPage /> },
        ]
    }
]